export default {"src":"/_next/static/media/404-light.fd7495de.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};